import { useAppSelector } from 'hooks/redux';
import React from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import OldDialog from './Deprecated';
import NewDialog from './New/billPresentmentDialog';

import type { BillPresentmentProps } from './actions';

function BillPresentmentDialog(props: BillPresentmentProps) {
  const fiServ = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'billsFiserv'));

  return fiServ ? <NewDialog {...props} /> : <OldDialog {...props} />;
}

BillPresentmentDialog.displayName = 'BillPresentmentDialog';

export default BillPresentmentDialog;
